import React from 'react';
import { NoInGdprInfo } from '../styledComponents/PetitionPage.styled';
import { useTranslation } from 'react-i18next';

const NoInGdprPopup = () => {
  const { t } = useTranslation();
  return (
    <NoInGdprInfo>
      <p>{t("petition_form.no_in_gdpr_popup")}</p>
    </NoInGdprInfo>
  );
};

export default NoInGdprPopup;
